<template>
  <div id="app">
    <transition name="fade">
      <loading v-show="isLoading"></loading>
    </transition>
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CommonMixin from '@/store/module/common/mixin'
import Loading from '@/components/UI/Loading'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'

export default {
  name: 'app',
  mixins: [CommonMixin],
  components: {
    [Loading.name]: Loading
  },
  methods: {
    ...mapActions({
      fetchLoggedInUserInfo: authActions.FETCH_USER_INFO
    })
  },
  mounted () {
    this.fetchLoggedInUserInfo()
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import "../scss/style.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue